/**
 * @fileoverview Legacy route for KOL Manager dashboard - redirects to /dashboard
 * @module routes/manager-dashboard
 * @deprecated Use /dashboard instead - it handles all user types
 */

import type { ReactElement } from 'react';
import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Loader2 } from 'lucide-react';

export const Route = createFileRoute('/manager-dashboard')({
  component: ManagerDashboardRedirect,
});

/**
 * Redirect component that sends users to the unified /dashboard route.
 * The /dashboard route handles all user types including kol_manager.
 *
 * @component
 * @deprecated Use /dashboard directly
 */
function ManagerDashboardRedirect(): ReactElement {
  const navigate = useNavigate();

  useEffect(() => {
    navigate({ to: '/dashboard', replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen bg-gray-950 flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-[#44FF02]" />
    </div>
  );
}
